import { useState, useEffect } from 'react';
import { Card, Descriptions, Form, Input, Button, message, Tag, Result } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getUser } from '../../api';

const API = import.meta.env.VITE_API_BASE || '/api';
const token = () => localStorage.getItem('ar_token');
const headers = () => ({ Authorization: `Bearer ${token()}` });

export default function PersonalCenter() {
  const navigate = useNavigate();
  const [user] = useState(() => getUser());
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pwdForm] = Form.useForm();

  // Admin cannot access this page
  if (user?.role === 3) {
    return (
      <Result
        status="403"
        title="个人中心仅对客户开放"
        subTitle="管理员请前往系统管理页面"
        extra={<Button type="primary" onClick={() => navigate('/home')}>返回首页</Button>}
      />
    );
  }

  useEffect(() => {
    axios.get(`${API}/auth/enterprise-info`, { headers: headers() })
      .then(r => setInfo(r.data.data))
      .catch(() => message.error('获取企业信息失败'));
  }, []);

  const handleChangePwd = async () => {
    try {
      const vals = await pwdForm.validateFields();
      setLoading(true);
      await axios.put(`${API}/auth/change-password`, vals, { headers: headers() });
      message.success('密码修改成功，请重新登录');
      pwdForm.resetFields();
      localStorage.removeItem('ar_token');
      setTimeout(() => navigate('/login'), 1500);
    } catch (e) {
      if (e.response?.data?.detail) message.error(e.response.data.detail);
      else if (!e.errorFields) message.error('操作失败');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 800 }}>
      <Card title={<><UserOutlined style={{ marginRight: 8 }} />企业信息</>} style={{ marginBottom: 16 }}>
        {info && (
          <Descriptions column={2} bordered size="small">
            <Descriptions.Item label="客户代码">{info.cCusCode}</Descriptions.Item>
            <Descriptions.Item label="企业名称">{info.ccusname}</Descriptions.Item>
            <Descriptions.Item label="角色类型">{info.roleName}</Descriptions.Item>
            <Descriptions.Item label="经销商类型">{info.dealerType}</Descriptions.Item>
            <Descriptions.Item label="登录账号">{info.loginName}</Descriptions.Item>
            <Descriptions.Item label="所属区域">{info.regionName || '-'}</Descriptions.Item>
          </Descriptions>
        )}
      </Card>

      <Card title={<><LockOutlined style={{ marginRight: 8 }} />修改密码</>}>
        <Form form={pwdForm} layout="vertical" style={{ maxWidth: 400 }}>
          <Form.Item name="old_password" label="原密码" rules={[{ required: true, message: '请输入原密码' }]}>
            <Input.Password placeholder="请输入原密码" />
          </Form.Item>
          <Form.Item name="new_password" label="新密码" rules={[
            { required: true, message: '请输入新密码' },
            { min: 6, message: '密码长度不能少于6位' },
          ]}>
            <Input.Password placeholder="请输入新密码（至少6位）" />
          </Form.Item>
          <Form.Item name="confirm" label="确认新密码" dependencies={['new_password']} rules={[
            { required: true, message: '请确认新密码' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) return Promise.resolve();
                return Promise.reject(new Error('两次输入的新密码不一致'));
              },
            }),
          ]}>
            <Input.Password placeholder="请再次输入新密码" />
          </Form.Item>
          <Button type="primary" onClick={handleChangePwd} loading={loading}>
            修改密码
          </Button>
        </Form>
      </Card>
    </div>
  );
}
